import React from 'react';
import CreateServerWrapper from './createNewMonitor/CreateServerWrapper';

const ServersCreatePage = () => {
    document.title = 'Create New Monitor - SyAgent';

    return (<CreateServerWrapper/>);

};

export default ServersCreatePage;
